module.exports = __webpack_public_path__ + "media/images/flags/64/Cocos-Keeling-Islands-bff31f35e081fbfd2677ba6670283213.png";